import { createUseStyles } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import { CaretRightIcon } from '@glu/icons-react';
import classnames from 'classnames';
import styles from './Breadcrumbs.styles';
import './themeDefaults';

const useStyles = createUseStyles(styles);

const Breadcrumbs = ({
  dark,
  onStepSelect,
  path,
  setParentName,
  setPath
}) => {
  const classes = useStyles();

  return path.length > 0 && (
    <div className={classnames(classes.root, { [classes.dark]: dark })}>
      <button
        className={classes.breadcrumb}
        data-qa="breadcrumb-all"
        onClick={() => {
          if (onStepSelect) {
            onStepSelect(undefined);
          } else {
            setParentName(undefined);
          }
          setPath([]);
        }}
        type="button"
      >
        All
      </button>
      {path.map((step, index) => (
        <span key={step.id}>
          {index < path.length - 1
            ? (
              <>
                <CaretRightIcon width={6} className={classes.caret} />
                <button
                  className={classes.breadcrumb}
                  data-qa={`breadcrumb-${step.id}`}
                  onClick={() => {
                    if (onStepSelect) {
                      onStepSelect(path[index].id);
                    } else {
                      setParentName(path[index].id);
                    }
                    setPath(path.slice(0, index + 1));
                  }}
                  type="button"
                >
                  {step.name}
                </button>
              </>
            )
            : (
              <span>
                <CaretRightIcon width={6} className={classes.caret} />
                {step.name}
              </span>
            )}
        </span>
      ))}
    </div>
  );
};

Breadcrumbs.propTypes = {
  dark: PropTypes.bool.isRequired,
  onStepSelect: PropTypes.func,
  path: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number
  })).isRequired,
  setParentName: PropTypes.func.isRequired,
  setPath: PropTypes.func.isRequired
};

Breadcrumbs.defaultProps = {
  onStepSelect: undefined
};

export default Breadcrumbs;
